import { render, staticRenderFns } from "./Empleado.vue?vue&type=template&id=909c6b98&scoped=true&"
import script from "./Empleado.vue?vue&type=script&lang=js&"
export * from "./Empleado.vue?vue&type=script&lang=js&"
import style0 from "./Empleado.vue?vue&type=style&index=0&id=909c6b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909c6b98",
  null
  
)

export default component.exports